import { render, staticRenderFns } from "./ManageZone.vue?vue&type=template&id=c8767236&scoped=true"
import script from "./ManageZone.vue?vue&type=script&lang=js"
export * from "./ManageZone.vue?vue&type=script&lang=js"
import style0 from "./ManageZone.vue?vue&type=style&index=0&id=c8767236&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8767236",
  null
  
)

export default component.exports